export default "__VITE_ASSET__50f3a91e__"